<!--
 * @Description: 人力资源和生产力平台综合服务协议
 * @Author: ljl
 * @Date: 2024-07-25
-->
<template>
  <div class="contract-main" :style="{ height: modalHeight }">
    <div class="contract-content">
      <p class="title">自由职业者综合服务协议</p>
      <p class="text marginBottom23">
        本《自由职业者综合服务协议》（“本协议”）由以下双方于封页所写之日签署：
      </p>
      <p class="text marginBottom8">
        甲方：【{{ resCooperatorData.cooperatorName }}】
      </p>
      <p class="text marginBottom8">
        法定代表人：【{{ resCooperatorData.legalPerson }}】
      </p>
      <p class="text marginBottom23">
        统一社会信用代码：【{{ resCooperatorData.uscCode }}】
      </p>
      <p class="text marginBottom13">
        乙方：【{{ resCooperatorData.disCompanyName }}】
      </p>
      <p class="text marginBottom8">
        法定代表人：【{{ resCooperatorData.disCompanyLegalPerson }}】
      </p>
      <p class="text marginBottom23">
        统一社会信用代码：【{{ resCooperatorData.disCompanyUscCode }}】
      </p>

      <!-- 自营 -->
      <p class="text marginBottom13" v-if="this.resCooperatorData.distributeCompanySelfOperated">
        （具体主体名称见签署页，以下统称“乙方”）
      </p>

      <!-- 鉴于 -->
      <p class="title-h2">鉴于：</p>
      <p class="paragraph-block">
        1.
        甲方为一家依据中国法律设立的，需要若干提供营利性服务的自由职业者（<i class="font-bold">“从业者/经营者”</i>）为其或其用户/客户提供服务的主体。<br />
        2. 乙方为依照中国法律设立的有限责任公司，为{{
          !this.resCooperatorData.distributeCompanySelfOperated
            ? "【场景化慧用工人力资源和生产力平台——“慧用工”】的入驻服务商。"
            : "【“慧用工”互联网平台】的服务方。"
        }}<br />
        3.
        甲方委托乙方与适合的自由职业者为其提供本协议约定的共享经济平台服务以及相应的具体服务；乙方自愿接受甲方前述委托。<br />
        为此，根据国家法律有关规定，甲乙双方按照平等自愿、诚实信用的原则，订立本协议。
      </p>

      <!-- 第一条合作内容 -->
      <p class="title-h2">第一条合作内容</p>
      <p class="paragraph-block">
        1.1
        甲方因自身业务发展，需要一定数量的自由职业者提供若干服务（具体服务详见附件一）<br />
        1.2 乙方接受甲方委托为其提供自由职业者综合服务，包括但不限于： <br />
        <span class="font-text-indent">1.2.1 为甲方匹配或接受甲方自行提供的适合自由职业者；<br />
          1.2.2 接受甲方委托向自由职业者支付服务费；<br />
          1.2.3
          <i
            class="font-bold">根据《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》（2025年第16号），乙方作为扣缴义务人，对自由职业者取得的服务费履行个人所得税预扣预缴及代办增值税申报义务。</i><br />
          <i class="font-bold">特别声明：</i>本协议项下自由职业者收入性质由上述规范性文件规定为<i
            class="font-bold">劳务报酬所得</i>，但各方法律关系仍以约定及履行为准。</span>
      </p>
      <p v-if="!this.resCooperatorData.distributeCompanySelfOperated" class="paragraph-block">
        1.3甲乙双方的任务发布、承揽、电子协议签署、资金管理、发票管理、对账结算等信息管理及交易管理，通过慧用工系统在线管理及存证。<br />
        【特别提示】人力资源和生产力服务平台作为开放的场景化灵工管理系统，为贵方（作为用工需求方）与服务商提供信息展示、项目发布、项目接领及在线交易等技术服务。贵方作为依法独立享有民事权利和承担民事义务的法律主体，应基于自愿原则自由选择、自主选择合作对象，并对应独立承担合作风险和责任。本协议将由贵方与贵方自主选择合作的服务商共同缔结，在贵方与该服务商之间发生法律效力。
      </p>

      <!-- 第二条合作期限 -->
      <p class="title-h2">第二条合作期限</p>
      <p class="paragraph-block">
        2.1合作期【一年】自本协议签署之日起至<i>{{
          resCooperatorData.afterYear
          }}</i>
        年<i>{{ resCooperatorData.month }}</i>月<i>{{ resCooperatorData.day
          }}</i>日，若合作期已满但仍存在原合作期内相关权利义务尚未履行完毕事项，除另有约定外，双方应继续履行完毕该等事项。合作期满前【一个月】，双方协商是否续约。若未书面通知对方不再续约，则本协议以相同条件自动延续【一年】，最多顺延二次。<br />
        2.2双方特别约定，因国家或地方政策变化等原因导致乙方无法继续提供服务的，乙方有权单方选择终止本协议所涉及的合作，但应提前【10】天以书面形式通知甲方以便双方处理善后事宜（包括但不限于清算乙方平台内甲方未使用的预付款项等）。<br />
        2.3甲方有权根据其自身业务发展需求、与乙方合作情况等原因单方选择终止本协议合作事项，但应提前【5】个工作日通知乙方。
      </p>

      <!-- 第三条服务费及支付方式 -->
      <p class="title-h2">第三条服务费及支付方式</p>
      <p class="paragraph-block">
        3.1
        合作费用：甲方应就乙方提供的本协议下的综合服务支付甲方应付服务费，其金额应包含自由职业者基于其提供的符合标准的服务活动而取得的税前金额（“服务费”），以及乙方按结算标准收取的管理费。<br />
        3.2 收费标准：<br />
        <span>{{ computeMode != 3 ? "固定费率" : "甲方应付服务费=服务费+管理费"
        }}<br /><span v-if="computeMode == 3">管理费=服务费×管理费费率</span></span><br />
        管理费费率为：
      </p>

      <!-- <div class="margin-box">
        对于月总收入{{ resCooperatorData.monthAmountLimit }}万元以下（不包含{{
          resCooperatorData.monthAmountLimit
        }}万， 按照每个自然月计算，除双方另有约定外， 月总收入超过{{
          resCooperatorData.monthAmountLimit
        }}万元的自由职业者不适用本协议约定方式结算）
        的自由职业者，管理费费率为：
      </div> -->

      <!-- table 固定费率走原来的 -->
      <div class="table_box" v-if="computeMode != 3">
        <el-table :data="!!resCooperatorData.rate ? resCooperatorData.rate : []" border size="small">
          <el-table-column prop="" label="月交易总额（人民币元）">
            <template slot-scope="scope">
              <span v-if="scope.row.upperLimitAmount === '9999999999.00'">{{ scope.row.lowerLimitAmount }}以上</span>
              <span v-else>{{ scope.row.lowerLimitAmount }} ~
                {{ scope.row.upperLimitAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="costRate" label="管理费费率（%）"></el-table-column>
        </el-table>
      </div>
      <div class="table_box" v-else>
        <el-table :data="resRateData" border size="small">
          <template slot="append">
            <div class="remark">
              <div>备注：</div>
              <div>
                1、在每月协议履行过程中，因满足阶梯要求发生费率降低的情况时，乙方对已发生的服务费重新计算将差额部分以系统账户余额的形式补充至甲方账户内用于此后的服务费下发。
              </div>
              <div>
                2、当月最终阶梯管理费率生效至次月，即：当月起始费率以上一月度月总服务费对应费率执行。
              </div>
            </div>
          </template>
          <el-table-column width="70%" :align="'center'" prop="label" label="甲方自由职业者月服务费合计">
          </el-table-column>
          <el-table-column width="30%" :align="'center'" prop="value" label="管理费费率（%）">
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="margin-box">
        如甲方单方安排月收入超过
        {{
          resCooperatorData.monthAmountLimit
        }}万元的自由职业者通过本协议进行结算，乙方有权就该等自由职业者的当月总收入按照上述费率基础上再另行上调2-4.5%计收管理费，具体费率以系统为准，除此之外，若乙方因此遭受的其他经济损失，甲方应于补全该损失。
      </div> -->

      <p class="paragraph-block">
        3.2.1乙方资金支付流程：<br />
        （1）从甲方支付金额中拆分税前报酬；<br />
        （2）从该税前报酬中代扣： <br />
        &nbsp;&nbsp;&nbsp;&nbsp;a)个人所得税（按劳务报酬累计预扣法计算）；<br />
        &nbsp;&nbsp;&nbsp;&nbsp;b)增值税及附加（个人当月在互联网平台企业获取收入≤10万元免征）；<br />
        （3）向自由职业者支付 税后净额（税前报酬 - 代扣税费）
      </p>
      <p class="paragraph-block">
        3.3 甲方需在慧用工系统设立商户以便将服务费支付给乙方。在慧用工{{
          !this.resCooperatorData.distributeCompanySelfOperated ? "" : "平台"
        }}中，乙方为甲方设立的商户开设子账户，子账户的账号以慧用工中显示的子账户信息为准。甲方向该子账户进行的支付操作可被乙方确认为甲方的支付行为。乙方根据实际结算金额开具发票。
      </p>

      <p class="paragraph-block">
        3.4 甲方指定专门的工作人员((姓名:
        {{ resCooperatorData.operatorName }}，身份证号码:
        {{ resCooperatorData.operatorIdCard }}，手机号码:
        {{ resCooperatorData.operatorMobile }}，邮箱:
        {{ resCooperatorData.operatorEmail }}))在
        {{
          !this.resCooperatorData.distributeCompanySelfOperated
            ? "慧用工"
            : "乙方"
        }}
        平台进行账号操作，并妥善保管平台账户的登录账号及密码，对该人员账户的所有操作均予以认可。在前述工作人员发生变动时，甲方应主动、及时地办理账户的交接并修改密码。甲方操作过程中不得将系统账号、密码及手机号验证码交给其他组织与个人，否则由此造成的损失由甲方自行承担。
      </p>
      <p class="paragraph-block">
        3.5 甲方每次支付费用前，应通过{{
          !this.resCooperatorData.distributeCompanySelfOperated
            ? "慧用工系统"
            : "乙方结算系统"
        }}的专用账户与乙方核对该次已提供本协议约定之服务的自由职业者清单及服务费金额，并按双方确认的金额向乙方支付服务费及管理费。乙方应根据甲方在慧用工平台的开票申请【5】个工作日内向甲方开具对应金额的、合法的增值税发票，所开发票可以在所开具的平台账号中进行下载留存。甲方每次完成支付甲方应付服务费之日为结算日，乙方应于结算日【1】个工作日内向该次甲方应付服务费对应的自由职业者核算、清分并支付对应金额的税后报酬。
      </p>
      <p class="paragraph-block">
        3.6
        由于存在单个自由职业者当月在多个互联网平台取得收入的情况，就可能所产生的增值税代办申报特别约定：<br />
        <span class="font-text-indent">3.6.1
          自由职业者当月多平台总收入＞10万元时，乙方次月代办增值税补缴申报；<br />
          3.6.2 扣款顺序：<br />
          （1）优先从该人员后续收入中扣减补缴税款；<br />
          （2）扣款失败时，乙方有权从甲方预付账户划扣或在下笔付款追加扣除；<br />
          3.6.3 无论何种原因导致增值税补缴的，该补缴金额甲方承担连带责任。<br />
        </span>
      </p>
      <p class="flex_box_spn">
        <span class="text marginBottom8">3.7 甲方增值税开票信息如下：</span>
        <span class="text marginBottom8">公司名称：【{{ resCooperatorData.cooperatorName }}】</span>
        <span class="text marginBottom8">纳税人识别号：【{{ resCooperatorData.uscCode }}】</span>
        <span class="text marginBottom8">地址：【{{ resCooperatorData.invoiceAddress }}】</span>
        <span class="text marginBottom8">电话：【{{ resCooperatorData.invoicePhoneNo }}】</span>
        <span class="text marginBottom8">开户银行：【{{ resCooperatorData.invoiceBankName }}】</span>
        <span class="text marginBottom8">银行账号：【{{ resCooperatorData.invoiceBankNo }}】</span>
        <span class="text marginBottom8">发票种类：【{{ "增值税专用发票(6%)" }}】</span>
      </p>
      <p class="paragraph-block">
        3.8
        甲乙双方确认并保证上述账户信息/开票信息真实、准确，如有变更，应提前10个工作日书面通知对方，因怠于履行通知义务造成的一切后果自行承担。<br />
        3.9
        如甲方已按时足额支付服务费，但由于乙方原因造成乙方未能向自由职业者及时支付本协议项下的服务费，所导致的一切后果及违约责任由乙方承担。如因甲方未能及时支付服务费的，所导致的一切违约责任由甲方承担。
      </p>

      <p class="title-h2">第四条权利与义务</p>
      <p class="paragraph-block">
        4.1 甲方权利与义务<br />
        <span class="font-text-indent">
          4.1.1
          甲方应基于乙方所提供的综合服务按时足额向乙方支付服务费。<br />
          4.1.2
          甲方对自行提供的自由职业者的身份及收入真实性负责，并承诺其提供的自由职业者已如实披露跨平台收入。<br />
          4.1.3
          甲方理解并同意乙方定期/不定期对业务运营、合法合规情况进行检查。甲方同意届时接受并配合乙方进行业务查询、通过调单核查单笔交易详情等工作。<br />
          4.1.4
          甲方应当保证为自由职业者及其用户/客户安排的服务内容不违反法律、不有伤社会风化、不有损自由职业者的身心健康与安全、不违反公序良俗，充分保障自由职业者及乙方各项权益的有效实现。乙方对自由职业者因从事灵活就业服务活动与任何其他方所产生的任何法律关系、权利义务、责任、纠纷及争议不承担任何法律责任，该等任何权利义务、责任、纠纷及争议均应由自由职业者、甲方依法各自承担并自行解决。<br />
          4.1.5
          如基于甲方原因，包括但不限于项目内容、工作时长、甲方对自由职业者的实际管理等，造成自由职业者被相关机构认定为构成事实劳动/劳务关系，则由甲方最终承担全部法律责任。<br />
          4.1.6
          甲方不得从事违反法律、行政法规、规章、规范性文件的行为，如洗钱、偷税漏税及其他乙方认为不得使用乙方服务的行为，如因甲方未如实告知或隐瞒有关行为的，造成乙方损失的，由甲方承担全部责任。<br />
          4.1.7
          甲方知晓并确认，接受乙方发布任务的自由职业者仅限于符合自由职业者身份的个人，下列人员不属于本协议项下自由职业者的范畴：<br />
          &nbsp;&nbsp;（1）与甲方具有劳动/劳务合同关系或其他类似的劳动人事法律关系的人员；<br />
          &nbsp;&nbsp;（2）与甲方关联企业具有劳动/劳务合同关系或其他类似的劳动人事法律关系的人员；<br />
          &nbsp;&nbsp;（3）甲方及其关联企业的法定代表人、董事、监事、股东；<br />
          &nbsp;&nbsp;（4）与甲方或其关联企业签署《竞业禁止协议》或相关竞业约定的；<br />
          &nbsp;&nbsp;（5）军人、公职人员等国家法律法规和规章纪律规定禁止从事兼职或经商的人员；<br />
          上述甲方关联企业指，相互间直接或间接持有其中一方的股权总和达到25%或以上的；直接或间接同为第三者所拥有或控制股权达到25%或以上的；企业与另一企业(独立金融机构除外)之间借贷资金占企业实收资本50%或以上。
        </span>
        4.1.8
        甲方承诺对实现本协议合作目的所获取的自由职业者的个人信息进行保密，未经本人授权或非基于合法并可执行的法律、法规、司法行政公文、监管机构的要求或非为遵守适用法律法规、履行网络安全保护义务或非应对网络安全事件的需要，甲方不得将自由职业者个人信息披露给任何第三方；甲方承诺按照相关法律法规的要求对获得的自由职业者信息履行安全保护义务，保障信息载体网络免受干扰、破坏或未经授权的访问，防止甲方网络数据泄露或被窃取、篡改。<br />
        4.1.9
        甲方承诺向乙方提供或与乙方分享的个人信息已经获取个人信息主体同意;同时，甲方授权乙方为完成本协议合作之目的，使用甲方合法收集的个人信息（包括但不限于自然人姓名、身份证号、收款账户信息、接单数量及费用等）。上述“个人信息”是指，以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，包括但不限于自然人姓名、出生日期、身份证件号码、个人生物识别信息、住址、电话号码、收款账户信息、接单数量及费用等。<br />
      </p>
      <p class="paragraph-block">
        4.2 乙方权利与义务<br />
        <span class="font-text-indent">4.2.1
          乙方遵守国家法律、行政法规、规章规定，严格履行个人所得税扣缴申报及增值税代办义务。<br />
          4.2.2
          乙方就本协议项下为甲方和自由职业者提供的自由职业者综合服务，包括但不限于自由职业者通过乙方服务平台为甲方提供的营利性服务行为，乙方有权依约向甲方收取相应的服务费。<br />
          4.2.3
          乙方根据甲方确认的自由职业者任务完成的数量和质效核算、支付自由职业者的服务收入。<br />
          4.2.4
          乙方为甲方匹配自由职业者，主要指对自由职业者提供的书面材料进行程序审查，关于甲方或自由职业者对乙方隐瞒真实情况、提供虚假材料等行为由行为人自行承担法律责任。<br />
          4.2.5
          乙方基于甲方的业务需求和自由职业者的工作技能，有权就自由职业者从事的服务活动制定相应的服务标准，若乙方制定相应标准可敦促自由职业者遵守前述服务标准，该等敦促为平等主体之间的为实现合同目的的敦促，适用《中华人民共和国民法典》约束，且不导致乙方与自由职业者之间构成任何劳动或劳务关系。。<br />
          4.2.6
          乙方保留对可疑交易、虚假交易、非法交易、高风险交易或为他人虚假交易提供服务、帮助或便利行为的独立判断和确定，并按以下情况进行处理：<br />
          4.2.7
          如果乙方发现甲方可能涉及可疑交易、虚假交易、非法交易、高风险交易或为他人虚假交易提供服务、帮助或便利的，乙方有权暂停相应服务或报告国家相关职能部门。<br />
          4.2.8
          如遇相关国家职能部门的合法指示（包括但不限于查询、冻结、扣划、解冻），乙方将履行法定协助义务，按相关国家机关的指示行事。<br />
          4.2.9
          乙方不得从事违反法律及行政法规等行为（包括但不限于涉嫌洗钱、诈骗、偷税、漏税、逃税），相关国家机关介入调查时，乙方及有关人员依法予以协助并如实反映情况，不得阻挠、拒绝调查。<br />
          4.2.10
          乙方保证所选用的自由职业者应在指定网络平台上注册线上签署/或线下书面签署实质内容与附件四合同模板一致的《自由职业者服务协议》。甲方有权审核乙方选用的自由职业者的个人身份信息、相关能力水平并决定是否接受其承接服务。若甲方发现自由职业者未签署《自由职业者服务协议》，则甲方应以适当的方式督促其签署《自由职业者服务协议》。若自由职业者拒绝签署《自由职业者服务协议》，则视同该人员不属于乙方选用人员，甲方应拒绝该人员为其提供服务。如甲方选择接受该人员所提供之服务，则一切后果由甲方自负,乙方不承担本协议中约定之任何相关义务。<br />
          4.2.11
          乙方获取自由职业者的个人信息已取得本人授权同意，乙方有权为实现本协议合作目的留存并合法使用自由职业者的个人信息，乙方承诺对自由职业者所披露的个人信息进行保密，未经授权或非基于合法并可执行的法律、法规、法院命令、监管机构的要求或非为遵守适用法律法规、履行网络安全保护义务或非应对网络安全事件的需要，乙方（含股东会、董事会、监事会成员及高级管理人员）不得将自由职业者个人信息披露给任意第三方。乙方承诺将按照相关法律法规的要求，对自由职业者个人信息履行安全保护义务，保障信息载体网络免受干扰、破坏或未经授权的访问，防止乙方网络数据泄露或被窃取、篡改。<br />
          4.2.12
          乙方应当本着诚信合作、合法共赢的原则，勤勉履行本协议，维护甲方形象，不得损害甲方的合法权益。</span>
      </p>

      <p class="title-h2">第五条保密义务</p>
      <p class="paragraph-block">
        5.1
        本协议任何一方由于签署和履行本协议所获得的任何与另一方有关的机密资料信息以及本协议本身和本协议所描述的交易（包括但不限于自由职业者人员信息，简称“<i
          class="font-bold">保密资料</i>”），该一方均应严格保守秘密，并应促使其关联公司或附属公司严格保守秘密。<br />
        5.2 本协议终止后，本条的保密义务约定也将仍然持续有效。
      </p>

      <p class="title-h2">第六条违约责任</p>
      <p class="paragraph-block">
        6.1
        除本协议另有约定外，本协议任意一方不履行或不完全履行本协议约定的义务和承诺即构成违约。违约方应当负责赔偿其违约行为给守约方造成的一切经济损失（包括但不限于合理的律师费、诉讼费、公证费等）。<br />
        6.2
        本协议关于违约状态下的救济方法（包括但不限于要求承担违约责任和解除协议等）的条款是累加的，可以选择适用或同时适用。<br />
        6.3
        若任意一方违背了本协议中的任何约定，任意一方在向另一方出具书面违约提醒要求违约方履行协议或采取必要的经济补救措施后的30个自然日（含），未收到违约方书面回应的，除了在法律或资产方面向违约方主张赔偿外还有权终止本协议。<br />
        6.4
        因政府行为（包括但不限于因中国政府机关不授予或调整甲方、乙方相应经营资质或权利等）或其他不可抗力因素导致本协议部分条款或全部条款无法履行的，遭受该行为的一方不承担违约责任。<br />
        6.5
        本协议的期满或终止，不影响守约方依照本协议的约定追究违约方违约责任的权利。
      </p>

      <p class="title-h2">第七条适用法律与纠纷解决</p>
      <p class="paragraph-block">
        7.1 本协议适用中华人民共和国的法律，并且排除一切冲突法规的适用。<br />
        7.2
        当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关条款将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。<br />
        7.3
        因本协议引起的或与本协议有关的一切争议，甲乙双方应当通过友好协商解决，协商不成的，任何一方有权向北京仲裁委员会提出仲裁申请，依据该委员会届时有效的仲裁规则，以保密形式进行仲裁。仲裁裁决具有终局性，对协议双方均有约束力。
      </p>

      <p class="title-h2">第八条通知与送达</p>
      <p class="paragraph-block">
        8.1 任何与本协议有关的由一方发送给另一方的通知或其他通讯往来（“<i class="font-bold">通知</i>”）应当采用书面形式，并按照下列通讯地址或通讯号码或电子邮箱地址送达至被通知人。
      </p>

      <p class="paragraph-block">
        <span class="text marginBottom8">甲方</span>
        <span class="text marginBottom8">联系人：【{{ resCooperatorData.operatorName }}】</span>
        <span class="text marginBottom8">通讯地址：【{{ resCooperatorData.operatorAddress }}】</span>
        <span class="text marginBottom8">联系电话：【{{ resCooperatorData.operatorMobile }}】</span>
        <span class="text marginBottom23">电子邮箱：【{{ resCooperatorData.operatorEmail }}】</span>
        <span class="text marginBottom8">乙方</span>
        <span class="text marginBottom8">联系人：【{{ resCooperatorData.partyBName }}】</span>
        <span class="text marginBottom8">通讯地址：【{{ resCooperatorData.partyBAddress }}】</span>
        <span class="text marginBottom8">联系电话：【{{ resCooperatorData.partyBMobile }}】</span>
        <span class="text marginBottom8">电子邮箱：【{{ resCooperatorData.partyBEmail }}】</span>
      </p>

      <p class="paragraph-block">
        8.2 通过电子邮箱及其它电子方式送达时，发出之日即视为有效送达。<br />
        8.3
        通过快递等方式送达时，对方签收之日视为有效送达；对方拒收或退回的，视为签收。<br />
        8.4 上述联系方式同时作为有效司法送达地址。<br />
        8.5
        一方变更联系方式，应以书面形式通知对方；否则，该联系方式仍视为有效，由未通知方承担由此而引起的相关责任。<br />
        8.6
        本联系方式条款为独立条款，不受合同整体或其他条款的效力影响，始终有效。
      </p>

      <p class="title-h2">第九条其他</p>
      <p class="paragraph-block">
        9.1 本协议包含的所有特别提示及附件内容均与本协议正文具有同等法律效力。
        9.2
        本协议未尽事宜，双方应另行协商并签订补充协议，乙方任意主体与甲方签订的补充协议均视为甲方与乙方所有主体共同签订，在甲方与乙方所有主体间生效。本协议补充协议、附件均为本协议不可分割的组成部分，与本协议具有同等法律效力。<br />
        9.3
        双方确认，如甲方与乙方（任意主体）此前已经签署过《自由职业者综合服务协议》（包含合同名称不一致但主要内容相同的协议），本协议生效时则原协议自动终止。<br />
        9.4
        若本协议采用电子方式签署，则各方在相关系统或网站或客户端以点击确认、勾选同意或类似意思表示的形式签署即视为生效，与加盖物理印章或手写签名具有同等法律效力，各方均认可电子合同和电子签名的法律效力。<br />
        9.5
        本协议一式二份，甲乙双方各执一份，自双方签署之日起生效，本协议扫描件、复印件与原件具有同等法律效力。<br />
        （以下无正文）

        <span v-if="!this.resCooperatorData.distributeCompanySelfOperated" class="marginBottom23"
          style="display: block;">
          签署日期：{{ resCooperatorData.year }} 年{{
            resCooperatorData.month
          }}
          月{{ resCooperatorData.day }} 日
        </span>

        <span v-else class="marginBottom23" style="display: block;">[本页无正文，为【{{ resCooperatorData.year }}】年【{{
          resCooperatorData.month
        }}】月【{{
            resCooperatorData.day
          }}】日签署的《自由职业者综合服务协议》签署页]</span>
      </p>

      <p class="paragraph-block marginBottom23">
        甲方：【{{ resCooperatorData.cooperatorName }}】<br />
        （甲方盖章）
      </p>

      <p class="marginBottom23 paragraph-block">
        乙方：【{{ resCooperatorData.disCompanyName }}】<br />
        （乙方盖章）
      </p>

      <!-- 附件一 -->
      <div class="imgBox marginBottom23">
        <span class="marginTop80">附件一：</span>
        <div class="paragraph-content">
          <span>服务内容确认书</span>
          <span>
            本公司需要一定数量的自由职业者提供下列服务，现委托【慧用工平台】为本公司匹配或接受本公司自行寻找适合的自由职业者承接此业务。双方服务内容以本确认书为准。特此确认。
            <!-- 
            本公司因需要一定数量的自由职业者提供下列服务，现委托【{{
              !resCooperatorData.distributeCompanySelfOperated
                ? "乙方"
                : "慧用工平台"
            }}】为本公司匹配或接受本公司自行寻找合适的自由职业者承接此业务。双方服务内容以本确认书为准。特此确认。 -->

          </span>
        </div>
      </div>
      <div class="marginRight">
        <span class="text">(公章)</span>
        <span class="text">日期：【{{ resCooperatorData.year }}】年【{{
          resCooperatorData.month
        }}】月【{{ resCooperatorData.day }}】日</span>
      </div>

      <div class="marginBottom23">
        <el-table :data="!!resCooperatorData.serviceTypeList
          ? resCooperatorData.serviceTypeList
          : []
          " border size="small">
          <el-table-column prop="index" label="序号"></el-table-column>
          <el-table-column prop="serviceTypeName" label="服务类型"></el-table-column>

          <el-table-column label="发票类目">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.invoicingCategories" :key="index">
                {{ item }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 承诺书 -->
      <div class="paragraph-content marginBottom23">
        <p class="marginTop80">附件二：</p>
        <p class="title">承诺书</p>
        <span class="marginBottom8">
          为了维护慧用工入驻服务商及平台自身的合法权益，根据相关法律法规，本公司作出如下承诺：
        </span>
        <span>（一）本公司充分知悉以下情形不适用慧用工平台</span>
        <p class="commitment-block marginBottom8">
          1.医药行业涉及两票制的药品生产、批发、零售环节不适用慧用工平台服务。
          <br />
          2.贷款、担保、基金、期货证券、融资租赁相关业务不适用慧用工平台服务。
          <br />
          3.人力资源企业的劳务派遣、招聘外包、人力资源外包业务不适用慧用工平台服务。
          <br />
          4.建筑施工以及采矿业企业的生产环节、施工总承包、专业承包、劳务分包，不适用慧用工平台服务。
          <br />
          5.律师事务所、会计师事务所、税务师事务所、资产评估事务所等特殊设立的合伙企业的专业资质人员不适用慧用工平台服务。
          <br />
          6.
          交通运输、货物运输业务的运费和驾驶员的报酬不适用慧用工平台服务。
        </p>
        <span class="marginBottom8">（二）承诺</span>
        <p class="commitment-block marginBottom8">
          若本公司的行业或外包业务涉及上述任一情形的，本公司应拒绝使用慧用工平台服务；若本公司具备上述任一情形、仍使用慧用工平台及入驻服务商（本协议乙方签署主体）造成经济损失或使得慧用工平台及入驻服务商（本协议乙方签署主体）其分公司、子公司承担法律责任的，本公司承担赔偿责任。
        </p>

        <p class="marginRight">
          <span class="text">单位公章</span>
          <span class="text">【{{ resCooperatorData.year }}】年【{{
            resCooperatorData.month
          }}】月【{{ resCooperatorData.day }}】日</span>
        </p>
      </div>

      <!-- <div class="imgBox height796 marginBottom23">
      <img
        :src="
          `../../../../static/onLineContractSign/${
            !!resCooperatorData.distributeCompanySelfOperated
              ? 'img_xy_twelve.png'
              : 'franchise_xy_twelve.jpg'
          }`
        "
        alt=""
      />
    </div> -->

      <!-- 加盟模式 - 附件三 -->
      <div class="imgBox marginBottom23" v-if="!resCooperatorData.distributeCompanySelfOperated">
        <span class="marginTop80">附件三：</span>
        <div class="paragraph-content">
          <span>告 知 书</span>
          <span class="sec-span-two">尊敬的平台客户：</span>
          <span class="sec-span-three">
            以下公司为慧用工人力资源和生产力服务平台——“慧用工”的入驻服务商，满足我平台对服务商的所有考核要求，即：与平台自有服务商的服务标准一致，并且相关运营服务以及系统支撑均由慧用工提供相应支持，以确保贵公司的各项使用要求及管理需求，请贵公司放心选用该公司作为您的服务商。
          </span>
          <span class="sec-span-four">
            顺颂商祺！
          </span>
          <div class="marginRight">
            <span class="text">
              湖南慧用工信息技术有限公司
            </span>
            <span class="text">日期：【{{ resCooperatorData.year }}】年【{{
              resCooperatorData.month
            }}】月【{{ resCooperatorData.day }}】日</span>
          </div>
        </div>

        <!-- 服务商名单 -->
        <p class="text-block">入驻服务商名单：</p>

        <div class="marginBottom23">
          <el-table :data="!!resCooperatorData.joinHygDistributeCompanyNameList
            ? resCooperatorData.joinHygDistributeCompanyNameList
            : []
            " border size="small">
            <el-table-column prop="index" label="序号"></el-table-column>
            <el-table-column prop="companyName" label="公司名称"></el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 合作评估表 -->
      <div>
        <span class="sec-title">附件{{
          !resCooperatorData.distributeCompanySelfOperated ? "四" : "三"
        }}：</span>

        <div class="file3">
          <img width="100%" src="../../../../static/onLineContractSign/img_zyzyz_13@2x.jpg" />

          <div class="time-line text">
            日期：【{{ resCooperatorData.year }}】年【{{
              resCooperatorData.month
            }}】月【{{ resCooperatorData.day }}】日
          </div>
        </div>
        <div class="marginBottom23">
          <el-table :data="file3Data" border :span-method="objectSpanMethod" size="small">
            <el-table-column width="100px" prop="type" label="类型"></el-table-column>
            <el-table-column width="150px" prop="name" label="名称"></el-table-column>
            <el-table-column prop="desc" label="描述"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CODE } from "../../../service/axios_constants";
export default {
  props: {
    resCooperatorData: {
      type: Object,
      default: {}
    },
    computeMode: {
      type: Number,
      default: 0
    },
    resRateData: {
      type: Array,
      default: []
    },
    userMessage: {
      type: Object,
      default: {}
    },
    modalHeight: {
      type: String,
      default: ""
    },
    contractType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      file3Data: [
        { type: "公司信息", name: "公司全称", desc: "" },
        { type: "", name: "所属行业", desc: "" },
        { type: "", name: "公司网站/APP", desc: "" },
        {
          type: "合作场景说明",
          name: "自由职业岗位",
          desc: ""
        },
        { type: "", name: "场景描述", desc: "" },
        { type: "", name: "报酬计算方式", desc: "以实际工作量结算" },
        { type: "", name: "单人单月收入范围", desc: "" },
        { type: "", name: "自由职业人员数量", desc: "" },
        { type: "", name: "单月总下发额", desc: "" },
        { type: "", name: "真实性说明", desc: "甲方盖章" }
      ]
    };
  },
  mounted() {
    this.xhrWhitenessCooperatorData();
  },
  methods: {
    //xhr -- 合作评估表数据
    xhrWhitenessCooperatorData() {
      this.$http
        .postWhitenessCooperatorData({ contractType: this.contractType })
        .then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            this.file3Data[0].desc = res.data.cooperatorName;
            this.file3Data[1].desc = res.data.industryName;
            this.file3Data[2].desc = res.data.webSite;
            this.file3Data[3].desc = res.data.workTypeName;
            this.file3Data[4].desc = res.data.workTypeDesc;
            // this.file3Data[6].desc = res.data.workTypeDesc;
            // this.file3Data[5].desc = res.data.incomeRangeDesc;
            this.file3Data[6].desc = `最高单人单月不超过${res.data.monthAmountLimit}万`;
            this.file3Data[7].desc = res.data.settlementNumberDesc;
            this.file3Data[8].desc = res.data.estimatedVolumeDesc;
          }
        });
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          // 3行合并一列
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex === 3) {
          return {
            rowspan: 7,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 签署合同样式
.contract-main {
  width: 100%;
  overflow-x: hidden;

  .contract-content {
    width: 100%;
    padding: 0 140px;
    font-family: STKaitiSC, STKaitiSC;

    .title {
      font-weight: 600;
      font-size: 22px;
      color: #272727;
      margin: 40px 0 24px;
      text-align: center;
    }

    .text {
      display: block;
      font-weight: bold;
      font-size: 16px;
      color: #272727;
      line-height: 25px;
    }

    .imgBox {
      width: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    // h2标题
    .title-h2 {
      font-size: 16px;
      color: #272727;
      justify-content: space-between;
      margin-top: 12px;
      line-height: 25px;
      font-weight: 600;
    }

    // 文章内容
    .paragraph-block {
      font-size: 16px;
      color: #464646;
      justify-content: space-between;
      margin-top: 8px;
      line-height: 28px;

      .font-bold {
        font-style: normal;
        font-weight: bold;
        color: #272727;
      }

      .font-text-indent {
        width: 710px;
        margin: auto;
        display: block;
      }
    }

    .commitment-block {
      font-size: 16px;
      color: #464646;
      justify-content: space-between;
      line-height: 28px;
    }

    .indent_box,
    .indent20_box {
      font-family: STKaitiSC, STKaitiSC !important;
      font-size: 16px;
      color: #272727;
      text-indent: 5px;
      margin-top: 5px;

      .indent_box_span {
        margin-left: 136px;
        line-height: 30px;
      }

      span {
        &:nth-child(2) {
          margin-left: 17px;
        }

        i {
          text-align: center;
          display: inline-block;
          width: 103px;
          font-style: normal;
          border-bottom: 1px solid #272727;
        }
      }
    }

    .indent20_box {
      text-indent: 20px;
      margin-top: 0;
      white-space: nowrap;
    }

    .text_black {
      color: #272727;
      font-size: 16px;
    }

    .flex_row_box {
      display: flex;

      .box_one {
        width: 600px;
      }
    }

    .margin_box {
      margin-left: 20px;
      line-height: 30px;
      text-indent: 30px;
    }

    .margin-box {
      display: inline-block;
      margin-top: 5px;
      margin-left: 53px;
      font-family: STKaitiSC, STKaitiSC;
      font-size: 16px;
      color: #272727;
      line-height: 25px;
      text-align: left;
      font-style: normal;
    }

    .table_box {
      margin-left: 53px;
      margin-top: 12px;
      margin-bottom: 10px;
    }

    .flex_box {
      display: flex;
      font-size: 15px;
      color: #272727;
      justify-content: space-between;
      margin-top: 8px;

      span {
        display: block;
        width: 235px;
        text-indent: 5px;
      }

      div {
        line-height: 25px;

        span {
          display: block;
          width: 100%;
        }
      }

      i {
        text-align: center;
        display: inline-block;
        min-width: 180px;
        font-style: normal;
        border-bottom: 1px solid #272727;
      }
    }

    .flex_box_spn {
      font-size: 15px;
      color: #464646;
      margin-top: 8px;

      span {
        display: block;
        text-indent: 5px;
      }

      div {
        font-size: 15px;
        color: #464646;
        width: calc(100% - 45px);

        span {
          font-size: 16px;
          display: block;
          width: 100%;
        }
      }
    }

    .marginLeft {
      margin-left: 65px;
    }

    .marginRight {
      margin-right: 28rpx;

      span {
        display: block;
        text-align: right;
        margin-bottom: 23px;
      }
    }
  }
}

.marginBottom23 {
  margin-bottom: 23px;

  span {
    font-family: STKaitiSC, STKaitiSC;
    font-size: 16px;
    color: #272727;

    i {
      text-align: center;
      display: inline-block;
      width: 103px;
      font-style: normal;
      border-bottom: 1px solid #272727;
    }
  }
}

.marginBottom13 {
  margin-bottom: 13px;
}

.marginBottom8 {
  margin-bottom: 8px;
}

.height335 {
  height: 335px;
}

.height460 {
  height: 460px;
}

.height212 {
  height: 212px;
}

.height448 {
  height: 448px;
}

.height796 {
  height: 796px;
}

.display_flex_box {
  display: flex;
}

.title_center {
  width: 100%;
  text-align: center;
  margin-bottom: 12px;
}

.remark_box {
  padding: 12px;
  width: 100%;
  text-indent: 30px;
  color: #272727;
  line-height: 25px;
}

.remark_table {
  padding: 0 36px 0 18px;

  .table_rate {
    border: 1px solid #ebeef5;
    border-bottom: none;
    padding: 12px;
    font-size: 13px;
    line-height: 25px;

    div {
      margin-bottom: 6px;
    }
  }
}

.remark {
  padding: 0 12px;

  div {
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 25px;
  }
}

.padding_box {
  padding: 0 13px;
}

.file3 {
  position: relative;
  margin-bottom: 20px;

  .time-line {
    position: absolute;
    bottom: 20px;
    right: 15px;
    text-align: right;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #272727;
    line-height: 17px;
    font-style: normal;
  }
}

.tips_box {
  margin-top: 5px;
  font-family: STKaitiSC, STKaitiSC;
  font-size: 16px;
  color: #272727;
  line-height: 25px;
  font-style: normal;
}

.paddingTop40 {
  padding-top: 40px;
}

.marginTop80 {
  margin-top: 80px;
  display: block;
}

.paragraph-content {
  margin-top: 20px;
  line-height: 28px;

  span {
    display: block;
  }

  span:nth-child(1) {
    text-align: center;
    margin-bottom: 20px;
    font-size: 26px;
  }

  .sec-span-two {
    margin-bottom: 20px;
  }

  .sec-span-three {
    text-indent: 2em;
    display: block;
    justify-content: space-between;
  }

  .sec-span-four {
    text-indent: 2em;
    margin-top: 10px;
    margin-bottom: 50px;
  }
}

.text-block {
  margin-bottom: 20px;
}

.sec-title {
  display: block;
  font-family: STKaitiSC, STKaitiSC;
  font-size: 16px;
  color: #272727;
  margin-bottom: 20px;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/indexStatistic/component/contract.vue